import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { logout as logoutAction, setLang } from '../../store/auth/actions'
import { getParamsFromQueryString } from '../../utils/url'
import LogoImage from '../image/LogoImage'
import EditionImage from '../image/EditionImage'
import LanguageSelector from '../shared/Language'
import {
  container,
  fractalContainer,
  childContainer
} from './styles/AdminTemplate.style'

const AdminTemplate = ({ children, lang }) => {
  return (
    <div className={container}>
      {Object.keys(getParamsFromQueryString()).length === 0 && <LanguageSelector lang={lang} />}
      <div className={fractalContainer}>
        <EditionImage />
        <LogoImage />
      </div>
      <div className={childContainer}>
        {children}
      </div>
    </div>
  )
}

AdminTemplate.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.array
  ]).isRequired,
  lang: PropTypes.string
}

const mapStateToProps = ({ auth }) => ({
  lang: auth.lang
})

const mapDispatchToPros = dispatch =>
  bindActionCreators(
    {
      logout: logoutAction,
      setLang
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToPros)(AdminTemplate)
